<div class="row amount-wrapper currency-{{ donation.currency }}" [formGroup]="form">
	<div class="columns small-12">
		<label for="transaction-amount" [class.error]="inputValid() == false" [innerHtml]="(inputValid()? labelTextkey : errorTextkey) | translate: {currencySymbol: donation.currencySymbol, max: (absolutMaximum | number: '1.0-0'), decimal: (5.99 | number: '1.2-2')}"></label>
	</div>
	<!-- Buttons -->
	<div class="button-wrapper columns small-12" *ngIf="!showSlider">
		<div [class.has-decimals]="showDecimals" [class.has-large-amounts]="hasLargeAmount" *ngFor="let button of buttonConfig">
			<radio [(model)]="donation.amount" [value]="button.amount + ''" (click)="setButtonAmount(button.amount)" [name]="'donation_amount'" [label]="'<small>' + (button.label| translate) + '</small><strong>' + (button.amount | number: showDecimals ? '1.2-2' : '1.0-0' ) + ' ' + donation.currencySymbol + '</strong>'" [required]="true" [form]="form"></radio>
		</div>
		<div *ngIf="showMore">
			<button class="button inactive" (click)="showSlider = true">{{ 'amount.slider.toggle' | translate }}</button>
		</div>
	</div>

	<!-- Slider -->
	<div class="columns small-12">
		<div class="row slider-input-wrapper">
			<div class="columns small-4 medium-custom input-wrapper" *ngIf="showSlider">
				<input type="number" id="transaction-amount" #transactionAmount required [ngModel]="getFormattedAmount()" (blur)="valueChanged(transactionAmount.value)" (change)="valueChanged(transactionAmount.value)" formControlName="amount" (ngModelChange)="checkMaximum()">
				<div class="currency-symbol">{{ donation.currencySymbol }}</div>
				<p class="infotext medium-right" [style.top]="infotextHeight" [class.hidden]="showInfotext == false" id="amount-infotext" #amountInfotext><span [innerHTML]="infoTextTextkey | translate: {max: (absolutMaximum | number: '1.0-0'), min: sliderStart, currency: donation.currencySymbol}"></span><i class="twingle-X" tabindex="0" (keydown.space)="showInfotext = false" (keydown.enter)="showInfotext = false" (click)="showInfotext = false"></i></p>
			</div>
			<div class="columns small-8 medium-custom slider-wrapper end" [class.has-close-button]="hasButtons" *ngIf="showSlider">
				<div class="slider">
					<input type="range" min="0" max="100" step="0.5" (input)="sliderChanged($event)" (change)="sliderChanged($event)" [value]="sliderValue">
				</div>
				<a class="close" tabindex="0" *ngIf="hasButtons" (click)="switchbackToButtons()" (keydown.space)="switchbackToButtons()" (keydown.enter)="switchbackToButtons()"><i class="twingle-icon twingle-icon_X"></i></a>
			</div>
		</div>
	</div>
</div>
